// src/pages/ReportingDashboardPage.js
import Dashboard from '../components/Dashboard';

function ReportingDashboardPage() {
  return (
    <div>
      <Dashboard />
    </div>
  );
}

export default ReportingDashboardPage;